import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import Guid from "_shared/guids/guid";
import { isEqual } from "lodash";
import CompanyProfile from "marketplace/companies/profiles/company-profile";

export function buildUpdateCompanyProfilePayload(
  isVisible?: boolean,
  contactId?: Guid,
  originalProfile?: CompanyProfile,
  updatedProfile?: CompanyProfile,
): JsonPatchOperation[] {
  const payload: JsonPatchOperation[] = [];

  if (isVisible !== undefined) {
    payload.push({ op: "replace", path: "/isVisible", value: isVisible });
  }

  if (contactId) {
    payload.push({ op: "replace", path: "/contactId", value: contactId.value });
  }

  if (!originalProfile || !updatedProfile) return payload;

  if (!updatedProfile.name) throw new Error("Company name is required");

  if (updatedProfile.name !== originalProfile.name) {
    payload.push({ op: "replace", path: "/name", value: updatedProfile.name });
  }
  if (updatedProfile.yearEstablished !== originalProfile.yearEstablished) {
    payload.push({ op: "replace", path: "/yearEstablished", value: updatedProfile.yearEstablished });
  }
  if (updatedProfile.numberOfEmployees !== originalProfile.numberOfEmployees) {
    payload.push({ op: "replace", path: "/numberOfEmployees", value: updatedProfile.numberOfEmployees });
  }
  if (updatedProfile.description !== originalProfile.description) {
    payload.push({ op: "replace", path: "/description", value: updatedProfile.description });
  }
  if (!isEqual(updatedProfile.location, originalProfile.location)) {
    payload.push({ op: "replace", path: "/location", value: updatedProfile.location });
  }
  if (updatedProfile.website?.toString() !== originalProfile.website?.toString()) {
    payload.push({ op: "replace", path: "/website", value: updatedProfile.website?.toString() });
  }
  if (!isEqual(updatedProfile.categories, originalProfile.categories)) {
    payload.push({ op: "replace", path: "/categories", value: updatedProfile.categories });
  }

  return payload;
}
